/**
 * `/$org/apps/probe`: the stage — start an interview and hold it.
 * `?focus=<area>` (from Practice or a debrief) opens the call on one
 * examination area.
 *
 * @module routes/$org.apps.probe.index
 */
import { createFileRoute } from "@tanstack/react-router";

import { areaFromSlug, areaSlug } from "../components/apps/probe/probeArea";
import { ProbeStagePage } from "../components/apps/probe/ProbePage";

export interface ProbeStageSearch {
  readonly focus?: string;
}

function ProbeStageRouteView() {
  const { focus } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProbeStagePage
      focus={areaFromSlug(focus)}
      onFocusChange={(next) =>
        void navigate({ search: next === null ? {} : { focus: areaSlug(next) }, replace: true })
      }
    />
  );
}

export const Route = createFileRoute("/$org/apps/probe/")({
  validateSearch: (search: Record<string, unknown>): ProbeStageSearch =>
    typeof search.focus === "string" && areaFromSlug(search.focus) !== null
      ? { focus: search.focus }
      : {},
  component: ProbeStageRouteView,
});
